import { Col, Row, Space, Tag, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { Dictionary, PageData } from "../declarations";
import CodeBlock from "../components/CodeBlock";
import { Console, Hook, Unhook } from "console-feed";

const Tutorial: React.FC<{ pageData: PageData }> = ({ pageData }) => {
    const [html, setHtml] = useState<string>("");
    const [css, setCss] = useState<Dictionary[]>([]);
    const [js, setJs] = useState<Dictionary[]>([]);
    const [logs, setLogs] = useState<any[]>([]);
    const iframe = useRef<any>(null);
    const consoleRef = useRef<any>(null);

    useEffect(() => {

        const getHtml = async () => {
            var resp = await fetch(`./examples/${pageData.link}`);
            if (resp.ok) {
                setHtml(await resp.text());
            }
        }

        const getCss = async () => {
            var data: Dictionary[] = [];
            pageData.cssFiles.forEach(async (file) => {
                var resp = await fetch(`./examples/css/${file}`);
                if (resp.ok) {
                    data.push({
                        file: file,
                        content: await resp.text(),
                    });

                    setCss(data);
                }
            });
        }

        const getJs = async () => {
            var data: Dictionary[] = [];
            pageData.jsFiles.forEach(async (file) => {
                var resp = await fetch(`./examples/js/${file}`);
                if (resp.ok) {
                    data.push({
                        file: file,
                        content: await resp.text(),
                    });
                    setJs(data);
                }
            });
        }

        getHtml();
        getCss();
        getJs();
    }, [pageData]);

    useEffect(() => {
        Hook(
            ((iframe.current as any).contentWindow as any).console,
            (log) => setLogs((currLogs) => [...currLogs, log]),
            false,
        );
        return unhook;
    }, []);

    useEffect(() => {
        if ((window as any).PMA) {
            document.title = pageData.title + " - PMA.UI Examples " + (window as any).PMA.UI.getVersion();
        }
        else {
            document.title = pageData.title + " - PMA.UI Examples";
        }
    }, [pageData.title]);

    useEffect(() => {
        if (consoleRef.current)
            consoleRef.current.scrollTop = consoleRef.current.scrollHeight;
    }, [logs]);

    const unhook = () => {
        if (iframe.current)
            Unhook(((iframe.current as any).contentWindow as any).console);
    }

    return (<div className="site-layout-content">
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <div>
                <Typography.Title level={3}>{pageData.title}</Typography.Title>
                <div>
                    {pageData.tags.map((item) => { return <Tag key={item} color="blue">{item}</Tag> })}
                </div>
            </div>
            <Row gutter={[16, 16]}>
                <Col span={16}>
                    <iframe
                        title="content"
                        src={`./examples/${pageData.link}`}
                        height="680px"
                        width="100%"
                        frameBorder="0"
                        style={{ border: "1px solid #f0f0f0", overflow: "hidden" }}
                        ref={iframe}
                    />
                </Col>
                <Col span={8}>
                    <Typography.Title level={5}>Console</Typography.Title>
                    <div style={{ height: "580px", overflowY: "auto" }} ref={consoleRef}>
                        <Console logs={logs} styles={{ LOG_COLOR: "black" }} filter={["log"]} />
                    </div>
                </Col>
            </Row>
            <Typography.Paragraph><div dangerouslySetInnerHTML={{ __html: pageData.description }}></div></Typography.Paragraph>
            <CodeBlock key={pageData.link} type={"htmlbars"} file={pageData.link} content={html} />
            {css.map((css) => <CodeBlock key={css.file} type={"css"} file={css.file} content={css.content} />)}

            {js.map((js) => <CodeBlock key={js.file} type={"javascript"} file={js.file} content={js.content} />)}
        </Space>
    </div>);
};

export default Tutorial;